"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IsValidIp_1 = require("./IsValidIp");
var IsReserved_1 = require("./IsReserved");
var IsPrivate_1 = require("./IsPrivate");
var GetOctetArray_1 = require("./GetOctetArray");
var Contains_1 = require("./Contains");
var Ip = /** @class */ (function () {
    function Ip(ipaddress) {
        this.ip = ipaddress;
    }
    Ip.prototype.isValid = function () {
        return IsValidIp_1.isValidIp(this.ip);
    };
    Ip.prototype.isReserved = function () {
        return IsReserved_1.isReserved(this.ip);
    };
    Ip.prototype.isPrivate = function () {
        return IsPrivate_1.isPrivate(this.ip);
    };
    Ip.prototype.getOctetArray = function () {
        return GetOctetArray_1.getOctetArray(this.ip);
    };
    Ip.prototype.getOctet = function (octet) {
        return GetOctetArray_1.getOctet(this.ip, octet);
    };
    Ip.prototype.containedBy = function (network) {
        return Contains_1.contains(network, this.ip);
    };
    return Ip;
}());
exports.Ip = Ip;
function ip(ipaddress) {
    return new Ip(ipaddress);
}
exports.ip = ip;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJJcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHlDQUFnRDtBQUNoRCwyQ0FBcUQ7QUFDckQseUNBQXVEO0FBQ3ZELGlEQUF3RjtBQUN4Rix1Q0FBcUM7QUFFckM7SUFFRSxZQUFhLFNBQWlCO1FBQzVCLElBQUksQ0FBQyxFQUFFLEdBQUcsU0FBUyxDQUFBO0lBQ3JCLENBQUM7SUFDRCxvQkFBTyxHQUFQO1FBQ0UsTUFBTSxDQUFDLHFCQUFLLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQ3ZCLENBQUM7SUFDRCx1QkFBVSxHQUFWO1FBQ0UsTUFBTSxDQUFDLHVCQUFRLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQzFCLENBQUM7SUFDRCxzQkFBUyxHQUFUO1FBQ0UsTUFBTSxDQUFDLHFCQUFZLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQzlCLENBQUM7SUFDRCwwQkFBYSxHQUFiO1FBQ0UsTUFBTSxDQUFDLDZCQUFVLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQzVCLENBQUM7SUFDRCxxQkFBUSxHQUFSLFVBQVUsS0FBYTtRQUNyQixNQUFNLENBQUMsd0JBQWEsQ0FBQyxJQUFJLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxDQUFBO0lBQ3RDLENBQUM7SUFDRCx3QkFBVyxHQUFYLFVBQWEsT0FBZTtRQUMxQixNQUFNLENBQUMsbUJBQVEsQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUFDSCxTQUFDO0FBQUQsQ0FBQyxBQXZCRCxJQXVCQztBQXZCWSxnQkFBRTtBQXlCZixZQUFvQixTQUFpQjtJQUNuQyxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUMsU0FBUyxDQUFDLENBQUE7QUFDMUIsQ0FBQztBQUZELGdCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/Ip.ts
// module id = 21
// module chunks = 0